import React from 'react'
import { MoonLoader } from 'react-spinners';

const LoadingSpinner = () => {
    return (
        <div className='spinner-loading'>
            <div className='spinner-loading-content'>
                <MoonLoader color="#FFECE6" speedMultiplier={0.5}  />
            </div>

        </div>
    )
}

export default LoadingSpinner